import { render } from "./BeritaParent.vue?vue&type=template&id=e841223c"
import script from "./BeritaParent.vue?vue&type=script&lang=js"
export * from "./BeritaParent.vue?vue&type=script&lang=js"

import exportComponent from "D:\\helmi\\blitarenergi\\vue\\companyprofile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__